<template>
    <div>
        <div class="row">
            <div :class="propertyAvailable('text_autoscale') ? 'col-md-3' : (propertyAvailable('text_family') ? 'col-md-6' : 'col-md-12')" v-if="propertyAvailable('text_size')">
                <number-field
                    v-model="inner_properties.text_size"
                    :label="t_size + ' (pt)'"
                    :disabled="element_readonly('text_size')"
                    :limits="getFieldEvaluatedLimits('text_size')"
                    placeholder="30"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
            <div id="select-text_autoscale" class="col-md-9" v-if="propertyAvailable('text_autoscale')">
                <v-select
                    v-model="inner_text_autoscale_option"
                    :label="t_text_autoscale"
                    :disabled="element_readonly('text_autoscale')"
                    :items="[
                            {value: '0', text: t_text_autoscale_none},
                            {value: '3', text: t_text_autoscale_shrink},
                            {value: '4', text: t_text_autoscale_fit},
                        ]"
                    attach="#select-text_autoscale .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
            <div id="select-text_family" class="col-md-6" v-if="propertyAvailable('text_family') && !propertyAvailable('text_autoscale')">
                <v-autocomplete
                    v-model="inner_text_family"
                    :label="t_family"
                    :disabled="element_readonly('text_family')"
                    :items="fontsConfig"
                    attach="#select-text_family .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                    <template v-slot:item="{active, item}">
                        <span :style="{fontFamily: '\'' + item + '\''}">{{ item }}</span>
                    </template>
                </v-autocomplete>
            </div>
        </div>
        <div class="row">
            <div id="select-text_family" :class="propertyAvailable('text_color') ? 'col-md-6' : 'col-md-12'" v-if="propertyAvailable('text_family') && propertyAvailable('text_autoscale')">
                <v-autocomplete
                    v-model="inner_text_family"
                    :label="t_family"
                    :disabled="element_readonly('text_family')"
                    :items="fontsConfig"
                    attach="#select-text_family .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                    <template v-slot:item="{active, item}">
                        <span :style="{fontFamily: '\'' + item + '\''}">{{ item }}</span>
                    </template>
                </v-autocomplete>
            </div>
            <div class="col-md-6" v-if="propertyAvailable('text_color')">
                <colorpicker
                    :id="'primary_color-' + inner_properties['index']"
                    :label="t_color"
                    v-model="inner_properties.primary_color"
                    align-right
                    :disabled="element_readonly('text_color')">
                </colorpicker>
            </div>
        </div>


        <div class="row">
            <div :class="['form-group', propertyAvailable('primary_text_color') ? 'col-md-6' : 'col-md-12']"
                 v-if="propertyAvailable('primary_text_color')">
                <colorpicker
                    :id="'primary_color-' + inner_properties['index']"
                    :label="t_primary_color"
                    v-model="inner_properties.primary_color"
                    :disabled="element_readonly('primary_text_color')">
                </colorpicker>
            </div>
            <div class="form-group col-md-6"
                 v-if="propertyAvailable('secondary_text_color')">
                <colorpicker
                    :id="'secondary_color-' + inner_properties['index']"
                    :label="t_secondary_color"
                    v-model="inner_properties.secondary_color"
                    align-right
                    :disabled="element_readonly('secondary_text_color')">
                </colorpicker>
            </div>
        </div>

        <div class="row"
             v-if="propertyAvailable('text_align') || propertyAvailable('text_valign') ||
                   propertyAvailable('text_weight') || propertyAvailable('text_style') || propertyAvailable('text_decoration')">
            <div class="col-md-12">
                <v-btn-toggle v-if="propertyAvailable('text_align')"
                              v-model="inner_text_align"
                              class="m-r-sm m-b-sm"
                              mandatory>
                    <v-btn :disabled="element_readonly('text_align')">
                        <v-icon>mdi-format-align-left</v-icon>
                    </v-btn>
                    <v-btn :disabled="element_readonly('text_align')">
                        <v-icon>mdi-format-align-center</v-icon>
                    </v-btn>
                    <v-btn :disabled="element_readonly('text_align')">
                        <v-icon>mdi-format-align-right</v-icon>
                    </v-btn>
                </v-btn-toggle>

                <v-btn-toggle v-if="propertyAvailable('text_valign')"
                              v-model="inner_text_valign"
                              class="m-r-sm m-b-sm"
                              mandatory>
                    <v-btn :disabled="element_readonly('text_valign')">
                        <v-icon>mdi-format-vertical-align-top</v-icon>
                    </v-btn>
                    <v-btn :disabled="element_readonly('text_valign')">
                        <v-icon>mdi-format-vertical-align-center</v-icon>
                    </v-btn>
                    <v-btn :disabled="element_readonly('text_valign')">
                        <v-icon>mdi-format-vertical-align-bottom</v-icon>
                    </v-btn>
                </v-btn-toggle>

                <v-btn-toggle v-if="propertyAvailable('text_weight') || propertyAvailable('text_style') || propertyAvailable('text_decoration')"
                              v-model="inner_text_styles"
                              class="m-r-sm m-b-sm"
                              multiple>
                    <v-btn :disabled="element_readonly('text_weight')">
                        <v-icon>mdi-format-bold</v-icon>
                    </v-btn>
                    <v-btn :disabled="element_readonly('text_style')">
                        <v-icon>mdi-format-italic</v-icon>
                    </v-btn>
                    <v-btn :disabled="element_readonly('text_decoration')">
                        <v-icon>mdi-format-underline</v-icon>
                    </v-btn>
                </v-btn-toggle>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('drop_shadow')">
            <div class="col-md-12">
                <number-field
                    v-model="inner_properties.drop_shadow"
                    :label="t_dropshadow"
                    :disabled="element_readonly('drop_shadow')"
                    :limits="getFieldEvaluatedLimits('drop_shadow')"
                    placeholder="0"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>
    </div>
</template>

<script>
import commonDefinitionMixin from "./commonDefinitionMixin";
import utility from "../../../utility";

export default {
    mixins: [
        commonDefinitionMixin,
    ],
    props: [
        'value',
        'definition',
        'readonly',
        'advanced-privilege',
        'basic-privilege',
        'clearable',
    ],
    data: function () {
        return {
            t_size: Lang.langGet("Size"),
            t_family: Lang.langGet("Family"),
            t_color: Lang.langGet("Color"),
            t_primary_color: Lang.langGet("Primary Color"),
            t_secondary_color: Lang.langGet("Secondary Color"),
            t_fontformat: Lang.langGet("Format"),

            t_text_autoscale: Lang.langGet("Scale font automatically"),
            t_text_autoscale_none: Lang.langGet("Do not scale."),
            t_text_autoscale_vertical: Lang.langGet("Scale according to vertical size of bounding box."),
            t_text_autoscale_horizontal: Lang.langGet("Scale according to horizontal size of bounding box."),
            t_text_autoscale_shrink: Lang.langGet("Shrink if necessary to fit in bounding box."),
            t_text_autoscale_fit: Lang.langGet("Scale to fit in bounding box."),

            t_dropshadow: Lang.langGet("Drop Shadow in px"),

            inner_properties: {},
            fontsConfig: [],
        }
    },
    computed: {
        inner_text_autoscale_option: {
            get: function () {
                if(typeof this.inner_properties.text_autoscale === 'undefined' && (this.inner_properties.type === 'text' || this.inner_properties.type === 'rssfeed')) {
                    this.inner_properties.text_autoscale = '0';
                }
                if(this.inner_properties.text_autoscale) {
                    let autoscale = parseFloat(this.inner_properties.text_autoscale);
                    if (autoscale > 1) {
                    //    return '1';
                        return '0';
                    } else if (autoscale < -1) {
                        return '2';
                    } else if (autoscale === 1) {
                        return '3';
                    } else if (autoscale === -1) {
                        return '4';
                    } else {
                        return '0';
                    }
                }
                return '0';
            },
            set: function (val) {
                //if (val === '1') {
                if (val === '0') {
                    this.inner_properties.text_autoscale = '0';
                } else if (val === '3') {
                    this.inner_properties.text_autoscale = '1';
                } else if (val === '4') {
                    this.inner_properties.text_autoscale = '-1';
                } else {
                    this.inner_properties.text_autoscale = '0';
                }
            }
        },
        inner_text_family: {
            get: function () {
                if(! this.inner_properties.text_family) {
                    var keys = Object.keys(this.fontsConfig);
                    if (keys.length > 0) {
                        this.inner_properties.text_family = Object.keys(this.fontsConfig)[0];
                    }
                }
                return this.inner_properties.text_family;
            },
            set: function (val) {
                this.inner_properties.text_family = val;
            }
        },
        inner_drop_shadow: {
            get: function () {
                return this.innerFieldGetter('drop_shadow');
            },
            set: function (val) {
                this.innerFieldSetter('drop_shadow', val);
            }
        },
        inner_text_align: {
            get: function () {
                let aligns = ['left', 'center', 'right'];
                return aligns.indexOf(this.inner_properties.text_align);
            },
            set: function (val) {
                let aligns = ['left', 'center', 'right'];
                Vue.set(this.inner_properties, 'text_align', aligns[val]);
            }
        },
        inner_text_valign: {
            get: function () {
                let aligns = ['top', 'middle', 'bottom'];
                return aligns.indexOf(this.inner_properties.text_valign);
            },
            set: function (val) {
                let aligns = ['top', 'middle', 'bottom'];
                Vue.set(this.inner_properties, 'text_valign', aligns[val]);
            }
        },
        inner_text_styles: {
            get: function () {
                let styles = [];
                if (this.inner_properties.text_weight === 'bold') styles.push(0);
                if (this.inner_properties.text_style === 'italic') styles.push(1);
                if (this.inner_properties.text_decoration === 'underline') styles.push(2);
                return styles;
            },
            set: function (val) {
                this.inner_properties.text_weight = val.includes(0) ? 'bold' : '';
                this.inner_properties.text_style = val.includes(1) ? 'italic' : '';
                this.inner_properties.text_decoration = val.includes(2) ? 'underline' : '';
            }
        }
    },
    watch: {
        value: function() {
            this.inner_properties = this.value;
        },
    },
    methods: {
        elementProperties: function () {
            return this.definition;
        },
        initToBeScrolled: function (type, id, focusField=null) {
            if(focusField) {
                focusField.focus();
            }
            this.$emit('initToBeScrolled', {'type': type, 'id': id});
        },
        leaveElementToBeScrolled: function () {
            this.$emit('leaveElementToBeScrolled');
        },
        toggleBold: function () {
            if (this.inner_properties.text_weight !== 'bold') {
                this.inner_properties.text_weight = 'bold';
            } else {
                this.inner_properties.text_weight = '';
            }
        },
        toggleItalic: function () {
            if (this.inner_properties.text_style !== 'italic') {
                this.inner_properties.text_style = 'italic';
            } else {
                this.inner_properties.text_style = '';
            }
        },
        toggleUnderline: function () {
            if (this.inner_properties.text_decoration !== 'underline') {
                this.inner_properties.text_decoration = 'underline';
            } else {
                this.inner_properties.text_decoration = '';
            }
        },
    },
    mounted: function () {
        this.inner_properties = this.value;

        axios.get('/content/fonts/load/' + Laravel.activeProject).then((response) => {
            this.fontsConfig = Object.keys(response.data);
        }).catch((error) => {
            this.fontsConfig = [];
        });
    }
}
</script>
